var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEmergency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7,
    r: 7,
    fill: "#CB3A8A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2330_1773)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.814 6.31398L8.186 6.31396L12.4 6.31398V7.68598H8.186L6.814 7.68596L2.6 7.68598V6.31398H6.814Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2330_1773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.8,
    height: 9.8,
    fill: "white",
    transform: "translate(2.6 2.09998)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmergency);
export default __webpack_public_path__ + "static/media/icon-emergency.f35e8deceab6f8f7e9922eda4f8e8d04.svg";
export { ForwardRef as ReactComponent };